import { ThemeEvents, VariantUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";

class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest(".shopify-section, dialog");
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  /**
   * Updates the SKU when the variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSku = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    if (!event.detail.data.html) return;

    const productId = this.dataset.productId;
    let newSku = null;

    if (productId) {
      const allSkus = event.detail.data.html.querySelectorAll("product-sku");
      for (const skuEl of allSkus) {
        if (skuEl.dataset.productId === productId) {
          newSku = skuEl;
          break;
        }
      }
    }

    if (!newSku) {
      newSku = event.detail.data.html.querySelector("product-sku");
    }

    if (!newSku) return;

    morph(this, newSku, { childrenOnly: true });

    if (newSku.hasAttribute("hidden")) {
      this.setAttribute("hidden", "");
    } else {
      this.removeAttribute("hidden");
    }
  };
}

if (!customElements.get("product-sku")) {
  customElements.define("product-sku", ProductSku);
}
